import React from "react";
import { AiFillEye, AiFillGithub } from "react-icons/ai";
import { motion } from "framer-motion";
import AppWrap from "../../wrapper/AppWrap";
import MotionWrap from "../../wrapper/MotionWrap";
import ethindia from "../../assets/ethindia.gif";
import esummit from "../../assets/esummit.gif";
import cognizance from "../../assets/cognizance.gif";
import swiftdocker from "../../assets/SwiftDocker.png";
import persistent from "../../assets/Persistent.png";

// import { urlFor, client } from "../../client";
import "./Work.scss";

const Work = () => {
  const animateCard = { y: 0, opacity: 1 };

  const works = [
    {
      name: "MENextN",
      ImgUrl: ethindia,
      projectLink: "https://ethermions-eth-india22.vercel.app/",
      codeLink: "https://github.com/Averek7/Ethermions_ETHIndia22",
      title: "ZaPP",
      description: "Collateralize NFTs for loans",
      tags: "EthIndia'22, Bengaluru",
    },
    {
      name: "Blockchain",
      ImgUrl: cognizance,
      projectLink: "https://cognizance-bit-bots.vercel.app/",
      codeLink: "https://github.com/Averek7/Cognizance_BitBots",
      title: "Dval.io",
      description: "Value & Supply Chain System",
      tags: "Cognizance, IIT Roorkee",
    },
    {
      name: "Blockchain",
      ImgUrl: esummit,
      projectLink: "https://ecell-nitb-hack2k23-ma-pd.vercel.app/",
      codeLink: "https://github.com/Averek7/ecell_nitb_hack2k23_MaPD",
      title: "MaPD",
      description: "Decentralized Logistics System",
      tags: "E-Summit, MANIT Bhopal",
    },
    {
      name: "Article",
      ImgUrl: persistent,
      projectLink: "https://www.geeksforgeeks.org/how-to-use-docker-for-stateful-applications-with-persistent-volumes/",
      codeLink: "https://www.geeksforgeeks.org/how-to-use-docker-for-stateful-applications-with-persistent-volumes/",
      title: "Persistent Volume",
      description: "Docker For Stateful Applications",
      tags: "GeeksForGeeks",
    },
    {
      name: "Article",
      ImgUrl: swiftdocker,
      projectLink: "https://www.geeksforgeeks.org/docker-swift-application/",
      codeLink: "https://www.geeksforgeeks.org/docker-swift-application/",
      title: "Swift Application",
      description: "Deploying Swift Application using Docker",
      tags: "GeeksForGeeks",
    },
  ];

  return (
    <>
      <h2 className="head-text">
        <span>Projects </span> Here
      </h2>

      <div className="app__work-filter">
        {[
          "MEReactN & MENextN",
          "Blockchain",
          "Python",
          "Clones",
          "Servers",
          "Articles",
        ].map((item, index) => (
          <div key={index} className={`app__work-filter-item app__flex p-text`}>
            {item}
          </div>
        ))}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.2, delayChildren: 0.2 }}
        className="app__work-portfolio"
      >
        {works.map((work, index) => (
          <div className="app__work-item app__flex" key={index}>
            <div className="app__work-img app__flex">
              <img src={work.ImgUrl} alt={work.name} />

              <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{
                  duration: 0.25,
                  ease: "easeInOut",
                  staggerChildren: 0.2,
                }}
                className="app__work-hover app__flex"
              >
                <a href={work.projectLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillEye />
                  </motion.div>
                </a>
                <a href={work.codeLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillGithub />
                  </motion.div>
                </a>
              </motion.div>
            </div>

            <div className="app__work-content app__flex">
              <h4 className="bold-text" style={ {textAlign: "center" }}>{work.title}</h4>
              <p className="p-text" style={{ marginTop: 10, textAlign: "center" }}>
                {work.description}
              </p>

              <div className="app__work-tag app__flex">
                <p className="p-text">{work.tags}</p>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Work, "app__works"),
  "work",
  "app__primarybg"
);
